import {isEmpty, map} from 'lodash';
import React, {useState} from 'react';
import Carousel from 'shared/components/carousel';
import ImageModal from 'shared/components/modal/image-modal';
import {track} from 'src/utils/analytics';
import 'stylesheets/components/college-profile/college-images.scss';

interface Props {
  images: {
    added?: string[];
    ranked?: string[];
  };
  name: string;
  collegeId: string;
  userId: string;
  slug: string;
}

const CollegeImages = ({images, name, collegeId, userId, slug}: Props) => {
  const [lightBoxOpen, setLightBoxOpen] = useState(false);
  const [currentLightboxPage, setCurrentLightboxPage] = useState(0);
  const added = images.added ?? [];
  const ranked = images.ranked ?? [];

  const openLightbox = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const currentPage = e.currentTarget.id.split('-')[2];
    trackCollegeClick(currentPage);
    setLightBoxOpen(true);
    setCurrentLightboxPage(Number(currentPage));
  };

  const trackCollegeClick = (photoPosition: string | number) => {
    track('college-photo-click', {
      collegeId,
      studentId: userId,
      pictureURL: ranked.concat(added)[Number(photoPosition)],
      timeStamp: new Date(),
      photoPosition: Number(photoPosition) + 1,
    });
  };

  const thumbnailUrl = (url: string) => {
    const urlSplit = url.split('/');
    const thumbSplit = `${urlSplit
      .slice(0, 3)
      .join('/')}/college-photos-uploaded/${slug}/thumbs/${urlSplit[urlSplit.length - 1]
      .split('.')
      .join('-thumb.')}`;

    return thumbSplit;
  };

  const renderPhotos = () => {
    const combinedPhotos = ranked.concat(added);
    const remainingCount = combinedPhotos.length - 5;

    return map(combinedPhotos.slice(0, 6), (url, i) => (
      <div
        key={`thumbnail${i}`}
        className="college-photo-thumbnail"
        data-testid="college-photo-thumbnail"
      >
        <button id={`college-photo-${i}`} onClick={openLightbox}>
          <img key={`College Photo ${i}`} alt={`College ${i}`} src={thumbnailUrl(url)} />
          {i === 5 && (
            <div className="college-photo-remaining" data-testid="college-photo-remaining">
              <span className="remaining-count">{`+${remainingCount}`}</span>
            </div>
          )}
        </button>
      </div>
    ));
  };

  const photoTag = () => {
    const page = currentLightboxPage;
    const combinedPhotos = ranked.concat(added);

    return <img alt={`lightbox ${page}`} src={combinedPhotos[page]} />;
  };

  const imageCount = () => ranked.length + added.length;

  const handleClose = () => {
    setLightBoxOpen(false);
  };

  const changeLightboxPage = (pageDirection: number) => () => {
    const nextPage = currentLightboxPage + pageDirection;
    trackCollegeClick(nextPage);
    setCurrentLightboxPage(nextPage);
  };

  const renderedPhotos = renderPhotos();

  return (
    <div>
      {!isEmpty(renderedPhotos) && <Carousel>{renderedPhotos}</Carousel>}
      <ImageModal
        show={lightBoxOpen}
        onClose={handleClose}
        onPageChange={changeLightboxPage}
        image={photoTag()}
        name={name}
        currentPage={currentLightboxPage}
        imageCount={imageCount()}
      />
    </div>
  );
};

export default CollegeImages;
